import { MESSAGE_TYPE, MESSAGE_STATUS } from "../api/enums.js"
import userStore from './userStore';
import localForage from 'localforage';

/* 为了加速拉取离线消息效率，拉取时消息暂时存储到cacheChats,等
待所有离线消息拉取完成后，再统一放至vuex中进行渲染*/
let cacheChats = [];



export default {
	state: {
		activeChat: null,
		privateMsgMaxId: 0,
		groupMsgMaxId: 0,
		loadingPrivateMsg: false,
		loadingGroupMsg: false,
		chats: [],
		drafts: {} // 存储草稿内容，key为chatId，value为草稿内容
	},

	mutations: {
		initChats(state, chatsData) {
			state.chats = [];
			state.privateMsgMaxId = chatsData.privateMsgMaxId || 0;
			state.groupMsgMaxId = chatsData.groupMsgMaxId || 0;
			cacheChats = chatsData.chats || [];
			// 防止图片一直处在加载中状态，并确保旧数据兼容性
			cacheChats.forEach((chat) => {
				// 为旧数据添加置顶字段
				if (chat.pinned === undefined) {
					chat.pinned = false;
				}
				chat.messages.forEach((msg) => {
					if (msg.loadStatus == "loading") {
						msg.loadStatus = "fail"
					}
				})
			})
		},
		openChat(state, chatInfo) {
			let chats = this.getters.findChats()
			let chat = null;
			for (let idx in chats) {
				if (chats[idx].type == chatInfo.type &&
					chats[idx].targetId === chatInfo.targetId) {
					chat = chats[idx];
					// 如果不是置顶会话，更新时间让其排到非置顶会话的最前面
					if (!chat.pinned) {
						chat.lastSendTime = new Date().getTime();
						chat.stored = false;
						this.commit("sortChats", true);
					}
					break;
				}
			}
			// 创建会话
			if (chat == null) {
				chat = {
					targetId: chatInfo.targetId,
					type: chatInfo.type,
					showName: chatInfo.showName,
					headImage: chatInfo.headImage,
					lastContent: "",
					lastSendTime: new Date().getTime(),
					unreadCount: 0,
					messages: [],
					atMe: false,
					atAll: false,
					stored: false,
					delete: false,
					pinned: false // 置顶标记
				};
				chats.unshift(chat);
				// 新会话创建后排序
				this.commit("sortChats", true);
			}
		},
		activeChat(state, idx) {
			let chats = this.getters.findChats();
			state.activeChat = chats[idx];
		},
		resetUnreadCount(state, chatInfo) {
			let chats = this.getters.findChats();
			for (let idx in chats) {
				if (chats[idx].type == chatInfo.type &&
					chats[idx].targetId == chatInfo.targetId) {
					chats[idx].unreadCount = 0;
					chats[idx].atMe = false;
					chats[idx].atAll = false;
					chats[idx].stored = false;
					this.commit("saveToStorage");
					break;
				}
			}
		},
		readedMessage(state, pos) {
			let chat = this.getters.findChatByFriend(pos.friendId);
			chat.messages.forEach((m) => {
				if (m.id && m.selfSend && m.status < MESSAGE_STATUS.RECALL) {
					// pos.maxId为空表示整个会话已读
					if (!pos.maxId || m.id <= pos.maxId) {
						m.status = MESSAGE_STATUS.READED
						chat.stored = false;
					}
				}
			})
			this.commit("saveToStorage");
		},
		removeChat(state, idx) {
			let chats = this.getters.findChats();
			if (chats[idx] == state.activeChat) {
				state.activeChat = null;
			}
			chats[idx].delete = true;
			chats[idx].stored = false;
			this.commit("saveToStorage");
		},
		removePrivateChat(state, friendId) {
			let chats = this.getters.findChats();
			for (let idx in chats) {
				if (chats[idx].type == 'PRIVATE' &&
					chats[idx].targetId === friendId) {
					this.commit("removeChat", idx)
					break;
				}
			}
		},
		removeGroupChat(state, groupId) {
			let chats = this.getters.findChats();
			for (let idx in chats) {
				if (chats[idx].type == 'GROUP' &&
					chats[idx].targetId === groupId) {
					this.commit("removeChat", idx)
					break;
				}
			}
		},
		togglePin(state, idx) {
			// 加载中不操作，很耗性能
			if (this.getters.isLoading()) {
				return;
			}
			let chats = this.getters.findChats();
			if (idx >= 0 && idx < chats.length) {
				let chat = chats[idx];
				// 切换置顶状态
				chat.pinned = !chat.pinned;
				chat.stored = false;
				// 置顶操作需要立即重新排序
				this.commit("sortChats", true);
				this.commit("saveToStorage");
			}
		},
		// 保留 moveTop 方法以兼容旧代码，但现在它调用 togglePin
		moveTop(state, idx) {
			this.commit("togglePin", idx);
		},
		insertMessage(state, [msgInfo, chatInfo]) {
			let type = chatInfo.type;
			// 记录消息的最大id
			if (msgInfo.id && type == "PRIVATE" && msgInfo.id > state.privateMsgMaxId) {
				state.privateMsgMaxId = msgInfo.id;
			}
			if (msgInfo.id && type == "GROUP" && msgInfo.id > state.groupMsgMaxId) {
				state.groupMsgMaxId = msgInfo.id;
			}
			// 如果是已存在消息，则覆盖旧的消息数据
			let chat = this.getters.findChat(chatInfo);
			let message = this.getters.findMessage(chat, msgInfo);
			if (message) {
				Object.assign(message, msgInfo);
				// 撤回消息需要显示
				if (msgInfo.type == MESSAGE_TYPE.RECALL) {
					chat.lastContent = msgInfo.content;
				}
				chat.stored = false;
				this.commit("saveToStorage");
				return;
			}
			// 插入新的数据
			if (msgInfo.type == MESSAGE_TYPE.IMAGE) {
				chat.lastContent = "[图片]";
			} else if (msgInfo.type == MESSAGE_TYPE.FILE) {
				chat.lastContent = "[文件]";
			} else if (msgInfo.type == MESSAGE_TYPE.AUDIO) {
				chat.lastContent = "[语音]";
			} else if (msgInfo.type == MESSAGE_TYPE.ACT_RT_VOICE) {
				chat.lastContent = "[语音通话]";
			} else if (msgInfo.type == MESSAGE_TYPE.ACT_RT_VIDEO) {
				chat.lastContent = "[视频通话]";
			} else if (msgInfo.type == MESSAGE_TYPE.TEXT ||
				msgInfo.type == MESSAGE_TYPE.RECALL ||
				msgInfo.type == MESSAGE_TYPE.TIP_TEXT) {
				chat.lastContent = msgInfo.content;
			}
			chat.lastSendTime = msgInfo.sendTime;
			chat.sendNickName = msgInfo.sendNickName;
			// 未读加1
			if (!msgInfo.selfSend && msgInfo.status != MESSAGE_STATUS.READED &&
				msgInfo.type != MESSAGE_TYPE.TIP_TEXT) {
				chat.unreadCount++;
			}
			// 是否有人@我
			if (!msgInfo.selfSend && chat.type == "GROUP" && msgInfo.atUserIds &&
				msgInfo.status != MESSAGE_STATUS.READED) {
				let userId = userStore.state.userInfo.id;
				if (msgInfo.atUserIds.indexOf(userId) >= 0) {
					chat.atMe = true;
				}
				if (msgInfo.atUserIds.indexOf(-1) >= 0) {
					chat.atAll = true;
				}
			}
			// 间隔大于10分钟插入时间显示
			if (!chat.lastTimeTip || (chat.lastTimeTip < msgInfo.sendTime - 600 * 1000)) {
				chat.messages.push({
					sendTime: msgInfo.sendTime,
					type: MESSAGE_TYPE.TIP_TIME,
				});
				chat.lastTimeTip = msgInfo.sendTime;
			}
			// 根据id顺序插入，防止消息乱序
			let insertPos = chat.messages.length;
			// 防止 图片、文件 在发送方 显示 在顶端  因为还没存库，id=0
			if (msgInfo.id && msgInfo.id > 0) {
				for (let idx in chat.messages) {
					if (chat.messages[idx].id && msgInfo.id < chat.messages[idx].id) {
						insertPos = idx;
						console.log(`消息出现乱序,位置:${chat.messages.length},修正至:${insertPos}`);
						break;
					}
				}
			}
			chat.messages.splice(insertPos, 0, msgInfo);
			chat.stored = false;
			this.commit("saveToStorage");
			
			// 新消息到达时重新排序会话列表，确保最新聊天的会话排在最前面
			this.commit("sortChats");
		},
		updateMessage(state, [msgInfo, chatInfo]) {
			// 获取对方id或群id
			let chat = this.getters.findChat(chatInfo);
			let message = this.getters.findMessage(chat, msgInfo);
			if (message) {
				// 属性拷贝
				Object.assign(message, msgInfo);
				chat.stored = false;
				this.commit("saveToStorage");
			}
		},
		deleteMessage(state, [msgInfo, chatInfo]) {
			let chat = this.getters.findChat(chatInfo);
			for (let idx in chat.messages) {
				// 已经发送成功的，根据id删除
				if (chat.messages[idx].id && chat.messages[idx].id == msgInfo.id) {
					chat.messages.splice(idx, 1);
					break;
				}
				// 正在发送中的消息可能没有id，根据发送时间删除
				if (msgInfo.selfSend && chat.messages[idx].selfSend &&
					chat.messages[idx].sendTime == msgInfo.sendTime) {
					chat.messages.splice(idx, 1);
					break;
				}
			}
			chat.stored = false;
			this.commit("saveToStorage");
		},
		prependMessages(state, [messages, chatInfo]) {
			// 批量将历史消息插入到消息列表前面
			let chat = this.getters.findChat(chatInfo);
			if (!chat || !messages || messages.length === 0) {
				return;
			}
			
			// 记录最大消息ID
			messages.forEach(msgInfo => {
				if (msgInfo.id && chatInfo.type == "PRIVATE" && msgInfo.id > state.privateMsgMaxId) {
					state.privateMsgMaxId = msgInfo.id;
				}
				if (msgInfo.id && chatInfo.type == "GROUP" && msgInfo.id > state.groupMsgMaxId) {
					state.groupMsgMaxId = msgInfo.id;
				}
			});
			
			// 将历史消息插入到消息列表前面
			chat.messages.unshift(...messages);
			chat.stored = false;
			this.commit("saveToStorage");
		},
		updateChatFromFriend(state, friend) {
			let chat = this.getters.findChatByFriend(friend.id);
			// 优先使用备注名称，如果没有备注名称则使用昵称
			let displayName = friend.remarkName || friend.nickName;
			// 更新会话中的群名和头像
			if (chat && (chat.headImage != friend.headImageThumb ||
				chat.showName != displayName)) {
				chat.headImage = friend.headImageThumb;
				chat.showName = displayName;
				chat.stored = false;
				this.commit("saveToStorage")
			}
		},
		updateChatFromGroup(state, group) {
			let chat = this.getters.findChatByGroup(group.id);
			if (chat && (chat.headImage != group.headImageThumb ||
				chat.showName != group.showGroupName)) {
				// 更新会话中的群名称和头像
				chat.headImage = group.headImageThumb;
				chat.showName = group.showGroupName;
				chat.stored = false;
				this.commit("saveToStorage")
			}
		},
		loadingPrivateMsg(state, loading) {
			state.loadingPrivateMsg = loading;
			if (!this.getters.isLoading()) {
				this.commit("refreshChats")
			}
		},
		loadingGroupMsg(state, loading) {
			state.loadingGroupMsg = loading;
			if (!this.getters.isLoading()) {
				this.commit("refreshChats")
			}
		},
		sortChats(state, immediate = false) {
			// 加载中不排序，防止性能问题
			if (this.getters.isLoading()) {
				return;
			}
			
			const sortFunction = (chat1, chat2) => {
				// 生成chatId用于检查草稿
				const getChatId = (chat) => `${chat.type}-${chat.targetId}`;
				const chat1Id = getChatId(chat1);
				const chat2Id = getChatId(chat2);
				const chat1HasDraft = !!state.drafts[chat1Id];
				const chat2HasDraft = !!state.drafts[chat2Id];
				
				// 首先按置顶状态排序，置顶的在前面
				if (chat1.pinned && !chat2.pinned) {
					return -1;
				}
				if (!chat1.pinned && chat2.pinned) {
					return 1;
				}
				
				// 置顶状态相同时，有草稿的排在前面
				if (chat1.pinned && chat2.pinned) {
					if (chat1HasDraft && !chat2HasDraft) {
						return -1;
					}
					if (!chat1HasDraft && chat2HasDraft) {
						return 1;
					}
				}
				
				// 非置顶状态时，有草稿的排在置顶项之后
				if (!chat1.pinned && !chat2.pinned) {
					if (chat1HasDraft && !chat2HasDraft) {
						return -1;
					}
					if (!chat1HasDraft && chat2HasDraft) {
						return 1;
					}
				}
				
				// 其他情况按最后发送时间降序排列
				return chat2.lastSendTime - chat1.lastSendTime;
			};
			
			let chats = this.getters.findChats();
			chats.sort(sortFunction);
		},
		refreshChats(state) {
			if (!cacheChats) {
				return;
			}
			// 排序，置顶会话优先，有草稿的排在置顶项之后
			cacheChats.sort((chat1, chat2) => {
				// 生成chatId用于检查草稿
				const getChatId = (chat) => `${chat.type}-${chat.targetId}`;
				const chat1Id = getChatId(chat1);
				const chat2Id = getChatId(chat2);
				const chat1HasDraft = !!state.drafts[chat1Id];
				const chat2HasDraft = !!state.drafts[chat2Id];
				
				// 首先按置顶状态排序，置顶的在前面
				if (chat1.pinned && !chat2.pinned) {
					return -1;
				}
				if (!chat1.pinned && chat2.pinned) {
					return 1;
				}
				
				// 置顶状态相同时，有草稿的排在前面
				if (chat1.pinned && chat2.pinned) {
					if (chat1HasDraft && !chat2HasDraft) {
						return -1;
					}
					if (!chat1HasDraft && chat2HasDraft) {
						return 1;
					}
				}
				
				// 非置顶状态时，有草稿的排在置顶项之后
				if (!chat1.pinned && !chat2.pinned) {
					if (chat1HasDraft && !chat2HasDraft) {
						return -1;
					}
					if (!chat1HasDraft && chat2HasDraft) {
						return 1;
					}
				}
				
				// 其他情况按最后发送时间降序排列
				return chat2.lastSendTime - chat1.lastSendTime;
			});
			// 将消息一次性装载回来
			state.chats = cacheChats;
			// 清空缓存
			cacheChats = null;
			this.commit("saveToStorage");
		},
		saveToStorage(state) {
			// 加载中不保存，防止卡顿
			if (this.getters.isLoading()) {
				return;
			}
			let userId = userStore.state.userInfo.id;
			let key = "chats-" + userId;
			let chatKeys = [];
			// 按会话为单位存储，
			state.chats.forEach((chat) => {
				// 只存储有改动的会话
				let chatKey = `${key}-${chat.type}-${chat.targetId}`
				if (!chat.stored) {
					console.log(chatKey)
					if (chat.delete) {
						localForage.removeItem(chatKey);
					} else {
						localForage.setItem(chatKey, chat);
					}
					chat.stored = true;
				}
				if (!chat.delete) {
					chatKeys.push(chatKey);
				}
			})
			// 会话核心信息
			let chatsData = {
				privateMsgMaxId: state.privateMsgMaxId,
				groupMsgMaxId: state.groupMsgMaxId,
				chatKeys: chatKeys
			}
			localForage.setItem(key, chatsData)
			// 清理已删除的会话
			state.chats = state.chats.filter(chat => !chat.delete)
		},
		clear(state) {
			cacheChats = []
			state.chats = [];
			state.activeChat = null;
		},
		// 保存草稿
		saveDraft(state, { chatId, content }) {
			if (content && content.trim()) {
				state.drafts[chatId] = content;
			} else {
				delete state.drafts[chatId];
			}
		},
		// 清除草稿
		clearDraft(state, chatId) {
			delete state.drafts[chatId];
		},
		// 获取草稿
		getDraft(state, chatId) {
			return state.drafts[chatId] || '';
		}
	},
	actions: {
		loadChat(context) {
			return new Promise((resolve, reject) => {
				let userId = userStore.state.userInfo.id;
				let key = "chats-" + userId;
				localForage.getItem(key).then((chatsData) => {
					if (!chatsData) {
						resolve();
					} else if (chatsData.chats) {
						// 兼容旧版本
						context.commit("initChats", chatsData);
						resolve();
					} else if (chatsData.chatKeys) {
						const promises = [];
						chatsData.chatKeys.forEach(key => {
							promises.push(localForage.getItem(key))
						})
						Promise.all(promises).then(chats => {
							chatsData.chats = chats.filter(o => o);
							context.commit("initChats", chatsData);
							resolve();
						})
					}
				}).catch((e) => {
					console.log("加载消息失败")
					reject();
				})
			})
		}
	},
	getters: {
		isLoading: (state) => () => {
			return state.loadingPrivateMsg || state.loadingGroupMsg
		},
		findChats: (state, getters) => () => {
			if (cacheChats && getters.isLoading()) {
				return cacheChats;
			}
			return state.chats;
		},
		findChatIdx: (state, getters) => (chat) => {
			let chats = getters.findChats();
			for (let idx in chats) {
				if (chats[idx].type == chat.type &&
					chats[idx].targetId === chat.targetId) {
					chat = chats[idx];
					return idx
				}
			}
		},
		findChat: (state, getters) => (chat) => {
			let chats = getters.findChats();
			let idx = getters.findChatIdx(chat);
			return chats[idx];
		},
		findChatByFriend: (state, getters) => (fid) => {
			let chats = getters.findChats();
			return chats.find(chat => chat.type == 'PRIVATE' &&
				chat.targetId == fid)
		},
		findChatByGroup: (state, getters) => (gid) => {
			let chats = getters.findChats();
			return chats.find(chat => chat.type == 'GROUP' &&
				chat.targetId == gid)
		},
		findMessage: (state) => (chat, msgInfo) => {
			if (!chat) {
				return null;
			}
			for (let idx in chat.messages) {
				// 优先通过tmpId匹配（用于上传过程中的消息更新）
				if (msgInfo.tmpId && chat.messages[idx].tmpId &&
					chat.messages[idx].tmpId == msgInfo.tmpId) {
					return chat.messages[idx];
				}
				// 通过id判断（用于普通消息）
				if (msgInfo.id && msgInfo.id > 0 && chat.messages[idx].id == msgInfo.id) {
					return chat.messages[idx];
				}
			}
		}
	}
}